module.exports = __webpack_public_path__ + "static/media/05.01cfa070.jpg";